import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RequestTypeMode } from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import RouteKey from '../../routes/key';
import EditAccessConfiguration from '../../components/access-configuration/EditAccessConfiguration';

const { userGroupAccessConfiguration } = RouteKey.admin.child;
const { admin } = RouteKey.child;

const AdminEditAccessConfigurations = () => {
  const { uuid: groupUuid } = useParams<any>();
  const { t } = useTranslation();
  const history = useHistory();

  const back = () => {
    history.push(`/${admin}/${userGroupAccessConfiguration.route}`, {
      requestType: RequestTypeMode.AdminAccessConfiguration,
    });
  };

  const onSuccessSubmit = () => {
    history.push(`/${admin}/${userGroupAccessConfiguration.route}`, {
      requestType: RequestTypeMode.AdminAccessConfiguration,
      status: 'success',
      event: 'EDIT',
    });
  };

  return (
    <>
      <EditAccessConfiguration
        t={t}
        userGroupUuid={groupUuid}
        functionName="ADMIN_ACCESS_CONFIGURATION"
        showUserGroupTitle
        backButtonAction={back}
        onSuccessSubmitAction={onSuccessSubmit}
      />
    </>
  );
};
export default AdminEditAccessConfigurations;
